import _ from "underscore";
import TriStateSelectorTree from "../selectionTree/TriStateSelectorTree";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";
import TreeNode from "../../hierarchySelector/tree/TreeNode";

export default function UsersSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds)
{
    TriStateSelectorTree.call( this, rootNode, emptyMessageBuilder, collapsedNodeIds );
}

UsersSelectorTree.prototype = _.create(TriStateSelectorTree.prototype);

UsersSelectorTree.prototype.getLowLevelEntities = function(filterCallback)
{
    var users = [];
    _.each(this.getAllNodes(), function(node)
    {
        if (node.getType() == TreeNode.TYPE_USER && filterCallback(node.getValue()))
            users.push(node.getValue());
    });
    return users;
};

UsersSelectorTree.prototype.isSelectionChanged = function()
{
    return HierarchySelectorUtil.isSelectionChanged(this);
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/UsersSelectorTree.js